import { render, staticRenderFns } from "./driver_manager_roster_list.vue?vue&type=template&id=486b0d34&scoped=true&"
import script from "./driver_manager_roster_list.vue?vue&type=script&lang=js&"
export * from "./driver_manager_roster_list.vue?vue&type=script&lang=js&"
import style0 from "./driver_manager_roster_list.vue?vue&type=style&index=0&id=486b0d34&scoped=true&lang=css&"
import style1 from "./driver_manager_roster_list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b0d34",
  null
  
)

export default component.exports